const ICONS_SIZES = {
  lg: '4.5rem',
  md: '1.5rem',
  sm: '1rem',
  xs: '0.75rem'
}

export default ICONS_SIZES
